// src/constants/ChartConfig.js

export const CHART_COLORS = [
  '#4fc3f7', // Jasnoniebieski
  '#ff9800', // Pomarańczowy
  '#66bb6a', // Zielony
  '#ab47bc', // Fioletowy
  '#ef5350', // Czerwony
  '#29b6f6', // Niebieski
  '#ffeb3b'  // Żółty
];

export const AXIS_STYLE = {
  stroke: "#aaa",
  tick: { fontSize: 13, fill: '#bbb' },
  angle: -45,
  textAnchor: "end",
  height: 70
};

export const GRID_STYLE = {
  strokeDasharray: "3 3",
  stroke: "#333",
  vertical: false
};